var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-button-medium-orange"},[_c('button',{attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }